import React, { useState } from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import AnalyticsPage from "../../components/AnalyticsPage/AnalyticsPage";
import FunnelAnalyticsPage from "../../components/AnalyticsPage/FunnelAnalyticsPage";
import ChatConversionStats from "../../components/AnalyticsPage/ChatConversionStats";
import CallPatternStats from "../../components/AnalyticsPage/CallPatternStats";
import RevealLimboStats from "../../components/AnalyticsPage/RevealLimboStats";
import LoopFunnelStats from "../../components/AnalyticsPage/LoopFunnelStats";
import CuriouzzPromiseStats from "../../components/AnalyticsPage/CuriouzzPromiseStats";
import DeparturesBlock from "../../components/AnalyticsPage/DeparturesBlock";
import Loader from "../../components/child/Loder";

/**
 * Analytics and Reporting.
 *
 * Every panel now renders its OWN <AnalyticsSection>, which carries the card,
 * the real card-header, the icon tile and the <h5>. This page used to wrap each
 * one in `card > card-body` while the panel faked a heading inside that body,
 * and two of them rendered a second Bootstrap card inside the first, which is
 * where the double border and double padding came from.
 *
 * Panels own their own section because two of the titles are computed: the
 * Promise reads "tonight's plan" or "dry run" from the live flag, which this
 * page has no business knowing.
 *
 * Order is the operator's reading order, not the build order.
 */
const AnalyticsAndReporting = () => {
  const [loadingCount, setLoadingCount] = useState(0);

  const startLoading = () => setLoadingCount((c) => c + 1);
  const stopLoading = () => setLoadingCount((c) => Math.max(0, c - 1));

  const loading = loadingCount > 0;
  const io = { startLoading, stopLoading };

  return (
    <MasterLayout>
      <Breadcrumb title="Analytics And Reporting" />

      {loading && <Loader />}

      {/* The loop, the operator's first read */}
      <LoopFunnelStats {...io} />

      {/* What tonight's 6 PM tick will do, or would do while dormant */}
      <CuriouzzPromiseStats {...io} />

      {/* Connections into chat, and chat into a purchase */}
      <ChatConversionStats {...io} />

      {/* Push-timing tuning */}
      <RevealLimboStats {...io} />

      {/* Call and vanish watch */}
      <CallPatternStats {...io} />

      {/* Vault question completion against drop-off */}
      <AnalyticsPage {...io} />

      {/* The signup wizard. NOT the member loop at the top of this page. */}
      <FunnelAnalyticsPage {...io} />

      {/* Churn, kept OFF the funnel on purpose and given its own home so that
          taking it off did not take it off the page entirely. */}
      <DeparturesBlock {...io} />
    </MasterLayout>
  );
};

export default AnalyticsAndReporting;
